<template>
  <div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" size="mini" :model="searchForm" label-width="100px" ref="searchForm">
            <el-form-item label="平台SPU码" prop="spuCode">
              <el-input v-model.trim="searchForm.spuCode" placeholder="请输入SPU编码" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="产品型号" prop="spuName">
              <el-input v-model.trim="searchForm.spuName" placeholder="请输入产品型号" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="平台SKU码" prop="tSkuCode">
              <el-input v-model.trim="searchForm.tSkuCode" placeholder="请输入平台SKU码" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="SKU编码" prop="skuCode">
              <el-input v-model.trim="searchForm.skuCode" placeholder="请输入SKU编码" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="SKU名称" prop="skuName">
              <el-input v-model.trim="searchForm.skuName" placeholder="请输入SKU名称" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="在售店铺" class="checkbox">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              <el-checkbox-group v-model="checkStores" @change="handleCheckedStoreChange" style="display: inline-block; margin-left: 10px;">
                <el-checkbox v-for="item in stores" :label="item.id" :key="item.id">{{ item.optionValue }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" @click="selectList" class="green-btn" size="mini">搜索</el-button>
            <el-button @click="resetSearchForm" class="orange-btn" size="mini">重置</el-button>
          </template>
        </search-box>
      </template>

      <table-panel ref="tablePanel">
        <template v-slot:header-right>
          <el-button type="primary" size="small" class="green-btn" @click="addform">新增</el-button>
          <el-button type="primary" size="small" @click="uploadForm">编辑</el-button>
          <el-button type="primary" size="small" @click="handleUnbind">解绑</el-button>
          <el-button type="primary" class="green-btn" size="small" @click="importExcel">导入 </el-button>
          <el-button
            type="primary"
            class="green-btn"
            size="small"
            @click="exportExcel"
            v-loading.fullscreen.lock="loadingExport"
            element-loading-text="数据导出中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            >导出
          </el-button>
          <el-button
            v-if="expends.length === 0 || expends.length !== tableData.records.length"
            type="primary"
            class="green-btn"
            size="mini"
            @click="getExpends"
            >全部展开
          </el-button>
          <el-button v-else type="primary" class="green-btn" size="small" @click="cloneExpends">全部收起 </el-button>
        </template>
        <el-table
          :data="tableData.records"
          v-loading="loading"
          v-if="tableReload"
          border
          ref="tableRef"
          :height="maxTableHeight"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
          }"
          :cell-style="{ textAlign: 'center' }"
          :row-key="
            (row) => {
              return row.index;
            }
          "
          :expand-row-keys="expends"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column prop="code" label="平台SPU码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="name" label="产品型号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="store" label="在售店铺" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="name" label="包含SKU数量" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.skus.length }}</span>
            </template>
          </el-table-column>
          <el-table-column width="55" fixed="right" label="操作" type="expand">
            <template slot-scope="scope">
              <el-table :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" :data="scope.row.skus" border>
                <el-table-column prop="tskuCode" label="平台SKU码" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="code" label="SKU编码" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="name" label="SKU名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="model" label="型号" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="storeLocation" label="店铺定位" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="store" label="在售店铺" :show-overflow-tooltip="true">
                  <template slot-scope>
                    {{ scope.row.store }}
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="清仓销售状态" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="name" label="操作" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <el-button size="mini" class="green-btn" @click="removesku(scope.row)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right;">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onCurrentChange"
              :current-page="tableData.pageNum"
              :page-sizes="[30, 100, 500, 1000]"
              :page-size="tableData.pageSize"
              :total="tableData.total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>

    <!-- 新增/编辑弹窗组件 -->
    <add-edit-dialog
      ref="addEditDialog"
      :visible.sync="addDialogVisible"
      :formType="formType"
      :modifyData="selectedSpuData"
      :stores="stores"
      @success="onDialogSuccess"
      @open-select-sku="onOpenSelectSku"
    />

    <!-- 选择SKU弹窗组件 -->
    <select-sku-dialog
      :visible.sync="selectSkuVisible"
      :existingSkus="existingSkus"
      @confirm="onSkuSelected"
    />
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import axios from "@/utils/axiosInstance";
import { baseUrl } from "@/utils/constant";
import moment from "moment";
import AddEditDialog from './components/add-edit-dialog.vue'
import SelectSkuDialog from './components/select-sku-dialog.vue'

export default {
  name: "Spu",
  components: {
    AddEditDialog,
    SelectSkuDialog
  },
  mixins: [pagePathMixin, tableMixin],
  data() {
    return {
      expends: [],
      loadingExport: false,
      loading: false,
      addDialogVisible: false,
      selectSkuVisible: false,
      existingSkus: [],
      checkStores: [],
      checkAll: false,
      isIndeterminate: false,
      stores: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchForm: {
        spuCode: null,
        spuName: null,
        skuCode: null,
        skuName: null,
        storeId: null,
        tSkuCode: null,
      },
      onRemoveSpuIds: [],
      selectSpus: [],
      formType: null,
      tableReload: true,
      selectedSpuData: {},
    };
  },
  methods: {
    exchange(row, rowList) {
      this.expends = rowList.map((item) => item.index);
    },
    cloneExpends() {
      this.expends = [];
    },
    getExpends() {
      var ids = this.tableData.records.map((item) => item.index);
      this.expends = ids;
    },
    getRowKeys(row) {
      return row.index;
    },
    uploadForm() {
      if (this.selectSpus.length !== 1) {
        this.$message.error("请选择具体的SPU");
        return;
      }
      this.formType = 1;
      this.selectedSpuData = this.selectSpus[0];
      this.addDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.onRemoveSpuIds = [];
      console.log("val", val);
      val.forEach((x) => {
        this.onRemoveSpuIds.push(x.id);
      });
      this.selectSpus = val;
      // if (val.length === 1) {
      //     this.selectSpus = val
      // }
    },
    handleUnbind() {
      if (this.onRemoveSpuIds.length == 0) {
        this.$message.error("请选择具体的SPU");
        return;
      }
      console.log(this.onRemoveSpuIds);
      this.$confirm("您确定解除该SPU绑定的SKU商品信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 点击确定
          this.$q.spu
            .unbindSku({
              data: JSON.stringify(this.onRemoveSpuIds),
            })
            .then((data) => {
              if (!data) {
                return;
              }
              if (data.code === "200") {
                this.$message({
                  message: "解绑SKU成功",
                  type: "success",
                });
                this.onSearch();
              } else {
                this.$message({
                  message: data.message,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          // 点击取消
        });
    },

    addform() {
      this.formType = 2;
      this.selectedSpuData = {};
      this.addDialogVisible = true;
    },
    onDialogSuccess() {
      this.onSearch();
      this.selectSpus = [];
    },
    onOpenSelectSku(existingSkus) {
      // 保存当前已选的SKU列表，用于过滤
      this.existingSkus = existingSkus;
      this.selectSkuVisible = true;
    },
    onSkuSelected(skus) {
      // 调用子组件方法添加SKU
      this.$refs.addEditDialog.addSkus(skus);
    },
    removesku(row) {
      console.log(row);
      this.$confirm("您确定在该SPU下移除该SKU商品信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          // 点击确定
          this.$q.spu
            .removeSky({
              params: { skuId: row.id, spuId: row.spuId, skuCode: row.code },
            })
            .then((data) => {
              if (!data) {
                return;
              }
              if (data.code === "200") {
                this.$message({
                  message: "移除SKU成功",
                  type: "success",
                });
                this.onSearch();
              } else {
                this.$message({
                  message: data.message,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          // 点击取消
        });
    },
    handleCheckedStoreChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.stores.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
    },
    handleCheckAllChange(val) {
      let ids = [];
      for (let index in this.stores) {
        ids.push(this.stores[index].id);
      }
      this.checkStores = val ? ids : [];
      this.isIndeterminate = false;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.checkStores = [];
      this.isIndeterminate = false;
      this.checkAll = false;
      this.onSearch();
    },
    selectList() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    getStores() {
      this.$q.goods.getConfigByOptionType({ params: { optionType: "5" } }).then((res) => {
        this.stores = res.data;
      });
    },
    onSearch() {
      this.loading = true;
      // 初始化多选框和关闭所有折叠
      this.expends = [];
      this.selectSpus = [];
      this.onRemoveSpuIds = [];
      if (this.$refs.tableRef) {
        this.$refs.tableRef.clearSelection();
      }
      const { spuCode, spuName, skuCode, skuName, tSkuCode, storeId } = this.searchForm;
      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          spuCode: spuCode,
          spuName: spuName,
          skuCode: skuCode,
          skuName: skuName,
          storeId: storeId,
          tskuCode: tSkuCode,
          storeIds: this.checkStores,
        },
      };
      this.$q.spu
        .listSpu({ data: JSON.stringify(param) })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.tableData.records.forEach((item, index) => {
              this.tableData.records[index] = {
                ...item,
                index: index,
              };
            });
          }
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      // 切换每页条数后从第一页搜索
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/dataImport/spuImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "SPU导入.xlsx",
          appCode: "ec-pc-api",
        },
      });
    },
    // 导出
    exportExcel() {
      // this.loadingExport = true;
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 2147483647;
      this.searchForm.exportTag = true;
      let params = {
        appCode: "ec-pc-api",
        paramMap: {
          ...this.searchForm,
        },
        reportName: "spuExport",
      };
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {
    this.getStores();
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>

.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
  border-color: #0BB78E;
  background-color: #0BB78E;
  color: #FFF;
  border-top: 0;
  border-bottom: 0;
}

.ant-divider, .ant-divider-vertical {
  position: relative;
  top: -.06em;
  display: inline-block;
  width: 1px;
  height: .8em;
  margin: 0 6px;
  vertical-align: middle;
  background-color: #0BB78E;
}

.avatar-uploader
  >>> .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden

    &:hover
      border-color: #409EFF;

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.upload-tip
  margin-left 30px
  margin-top -10px

.preview-content
  text-align center

  p
    margin-bottom 10px

  >>> .el-image
    width 200px
    height 200px

>>> .el-dialog__body
  padding 10px 15px

>>> .el-table__expanded-cell
  padding 10px
  background rgb(250, 250, 250)

.dialog-footer
  text-align center

>>> .checkbox
    width 100%

>>> .checkbox .el-form-item__content
  width 90%

>>> .checkbox .el-checkbox-group
  display block

.search-box
  >>> .search-left
    min-height 100px
</style>
